import React from 'react';
import './ProfileTab.css';

const ProfileTab = ({
  firstName,
  lastName,
  ign,
  birthdate,
  role,
  profile,
  saving,
  status,
  setFirstName,
  setLastName,
  setIgn,
  setBirthdate,
  setRole,
  saveProfile,
  auth,
}) => {
  return (
    <div className="settings-card">
      <h1>Account Settings</h1>
      <p className="settings-subtitle">Update your profile and identity.</p>

      <form className="settings-form profile-form" onSubmit={saveProfile}>
        <div className="settings-grid profile-grid">
          <label className="profile-field">
            <span className="profile-label">First Name</span>
            <input
              className="profile-input"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
            />
          </label>
          <label className="profile-field">
            <span className="profile-label">Last Name</span>
            <input
              className="profile-input"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
            />
          </label>
          <label className="profile-field profile-field--wide">
            <span className="profile-label">In-Game Name</span>
            <input
              className="profile-input"
              value={ign}
              onChange={(e) => setIgn(e.target.value)}
            />
            <small className="settings-hint">
              Shown on join requests and in team views.
            </small>
          </label>
          <label className="profile-field">
            <span className="profile-label">Birthdate</span>
            <input
              className="profile-input"
              type="date"
              value={birthdate}
              onChange={(e) => setBirthdate(e.target.value)}
            />
          </label>
          <label className="profile-field profile-field--role">
            <span className="profile-label">Role</span>
            <select
              className="profile-input profile-select"
              value={role}
              onChange={(e) => setRole(e.target.value)}
            >
              <option value="player">Player</option>
              <option value="coach">Coach</option>
              <option value="assistant_coach">Assistant Coach</option>
              <option value="analyst">Analyst</option>
            </select>
            <small className="settings-hint">
              Player: plays matches. Coach/Assistant Coach: run prep and scrims. Analyst:
              focuses on stats and review.
            </small>
          </label>
          {profile?.email && (
            <label className="profile-field profile-field--wide">
              <span className="profile-label">Email</span>
              <input className="profile-input" value={profile.email} readOnly />
              <small className="settings-hint">
                {auth?.currentUser?.emailVerified
                  ? 'Verified'
                  : 'Not verified yet – check your inbox.'}
              </small>
            </label>
          )}
        </div>

        <div className="profile-actions-row">
          <button className="settings-btn" type="submit" disabled={saving}>
            {saving ? 'Saving...' : 'Save changes'}
          </button>
          {status && <p className="settings-status">{status}</p>}
        </div>
      </form>
    </div>
  );
};

export default ProfileTab;
